<ng-container *ngIf="order$ | async as order">
  <ng-container *ngIf="order.cartSubTotals || order.subtotals; else loading">
    <eb-order-summary [cart]="order"></eb-order-summary>
  </ng-container>
</ng-container>
<ng-template #loading>
  <eb-spinner class="my-3 d-block"></eb-spinner>
</ng-template>
